import { defineMessages, useIntl } from 'react-intl';
import LogoSVG from './images/logo-header-desktop.svg';
import Wrapper from './Wrapper';

const LogoHeaderDesktop = ({ url, title, nolink, className }) => {
  const intl = useIntl();

  const messages = defineMessages({
    cop30LogoWide: {
      id: 'COP30 Brasil - Amazônia - Belém, 2025',
      defaultMessage: 'COP30 Brasil - Amazônia - Belém, 2025',
    },
  });

  return (
    <Wrapper
      url={url}
      title={title}
      nolink={nolink}
      className={className}
      src={LogoSVG}
      alt={intl.formatMessage(messages.cop30LogoWide)}
    />
  );
};

export default LogoHeaderDesktop;
